import { Injectable } from '@angular/core';
import { QuestionByIdQuery } from '@gql/graphql';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class FactCheckService {
  searchData: string;
  question: BehaviorSubject<(QuestionByIdQuery | { question_type_name?: string, question_type_id?: number  })> =  new BehaviorSubject(undefined);
  constructor() {}
}
